import { render } from "./Initialize.vue?vue&type=template&id=b8c247c0&ts=true"
import script from "./Initialize.vue?vue&type=script&lang=ts"
export * from "./Initialize.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__